import { type CLSMetric, type INPMetric, type LCPMetric, onCLS, onINP, onLCP } from 'web-vitals';
import { logEvent } from '@/common/api/logger';

export const collectWebVitals = (): void => {
  onCLS((metric) => logEvent({ step: 'web-vital', ...metricToMetadata(metric) }));

  onINP((metric) => logEvent({ step: 'web-vital', ...metricToMetadata(metric) }));

  onLCP((metric) => logEvent({ step: 'web-vital', ...metricToMetadata(metric) }));
};

function metricToMetadata(metric: CLSMetric | INPMetric | LCPMetric): Record<string, string | number> {
  return {
    metric: metric.name,
    value: metric.value,
    rating: metric.rating,
  };
}
